
// get nested property from object
// obj: json object with data
// key: array of property names or string with property names split by '.'
// def: default value returned when property is undefined
// returns: the property value if it exists 
//   or def if property is undefined 
export const getProperty = (obj, key, def) => {
    const keys = (key instanceof Array) ? key : key.split('.');
    const stop = keys.length - 1;
    for (let i = 0; i <= stop; i++) {
        if (obj === null || typeof obj === 'undefined') {
            return def
        };
        obj = obj[keys[i]];
    }
    return typeof obj === 'undefined' ? def : obj;
};

// creates a function that wraps the getProperty function, so that the key.split() has to be only once
// key: array of property names or string with property names split by '.'
// def: default value returned when property is undefined
// returns: a function that gets the property of the provided object
// example:
//   var data = {prop:{subProp:{name:"test"}}};
//   var getX = getPropertyW('prop.subProp.name');
//   getX(data) // "test"
export const getPropertyW = (key, def) => {
    const keys = (key instanceof Array) ? key : key.split('.');
    return obj =>
        getProperty(obj, keys, def);

};

// set nested property in object, creating any undefined or null intermediate properties as '{}'
// obj: json object with data
// key: array of property names or string with property names split by '.'
// val: value to set
// returns: nothing
export const setProperty = (obj, key, val) => {
    const keys = (key instanceof Array) ? key : key.split('.');
    const stop = keys.length - 1;
    let _obj = obj;
    for (let i = 0; i < stop; i++) {
        const temp = _obj[keys[i]];
        _obj = (!temp) ? _obj[keys[i]] = {} : temp;
    }
    _obj[keys[stop]] = val;
    return obj;
};

// creates a function that wraps the setProperty function, so that the key.split() has to be only once
// key: array of property names or string with property names split by '.'
// def: default value returned when property is undefined
// returns: a function that gets the property of the provided object
// example:
//   var data = {prop:{subProp:{name:"test"}}};
//   var setX = getPropertyW('prop.subProp.name');
//   setX(data,"test2") // data = {prop:{subProp:{name:"test2"}}};
export const setPropertyW = (key) => {
    const keys = (key instanceof Array) ? key : key.split('.');
    return (obj, val) =>
        setProperty(obj, keys, val);
};

// export shorthand alias
export const get = getProperty;
export const getW = getPropertyW;
export const set = setProperty;
export const setW = setPropertyW;


/*
///////////////////////////
// examples:
// getProperty
{
    const test = { test1: "_test", "test2": 1, test3: { a: "a" }, test4: ["a", "b", "c"], test5: { a: { b: { c: "c" } } } }
    console.log(getProperty(test, "test1")) // _test
    console.log(getProperty(test, "test2")) // 1
    console.log(getProperty(test, "test3")) // { a: "a" }
    console.log(getProperty(test, "test3.a")) // a
    console.log(getProperty(test, "test4")) // ["a", "b", "c"]
    console.log(getProperty(test, "test4.0")) // a
    console.log(getProperty(test, "test4.1")) // b
    console.log(getProperty(test, "test4.2")) // c
    console.log(getProperty(test, "test5.a.b.c")) // c
    console.log(getProperty(test, "test6")) // undefined
    console.log(getProperty(test, "test6", "default")) // default
}
// setProperty
{
    console.log(setProperty({}, "test1", "_test")); // { test1:"_test" }
    console.log(setProperty({}, "test2", 1)); // { test2:1 }
    console.log(setProperty({}, "test3.a", "a")); // { test3: { a: "a" } }
    {
        const test = {};
        console.log(setProperty(test, "test4", [])); // { test4: [] }
        console.log(setProperty(test, "test4.0", "a")); // { test4: ["a"] }
        console.log(setProperty(test, "test4.1", "b")); // { test4: ["a", "b"] }
        console.log(setProperty(test, "test4.2", "c")); // { test4: ["a", "b", "c"] }
    }
    console.log(setProperty({}, "test5.a.b.c", "c")); //  { test5: { a: { b: { c: "c" } } } }
    console.log(setProperty({}, "test6", undefined)); // { test6: undefined }
}
///////////////////////////
*/